// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"cb3f685c","703":"cf35effe","787":"effc2b7e"}[chunkId] + ".chunk.js";
};